<div class="footer-container" *ngIf="loginError">
  <div class="row">
    <div class="d-flex justify-content-center shadow">
      <!-- <p><i class="fa fa-copyright" aria-hidden="true"></i>2019 Toyota Motor Sales, U.S.A., Inc. All information applies to U.S. vehicles only.</p> -->
      <!-- <p>
        <i class="fa fa-facebook" aria-hidden="true" style="margin-right: 40px;"></i>
        <i class="fa fa-twitter" aria-hidden="true" style="margin-right: 40px;"></i>
        <i class="fa fa-youtube-play" aria-hidden="true" style="margin-right: 40px;"></i>
        <i class="fa fa-instagram" aria-hidden="true"></i>
      </p> -->
    </div>
  </div>
</div>
